module.exports = __webpack_public_path__ + "static/media/Peter.0c4f8d14.jpeg";